<template>
  <div>
    <canvas id="canvas" class="canvas"></canvas>
    <!-- <div onmousedown="mousedownFun(37)" onmouseup="mouseupFun(37)">向左(←)</div>
    <div onmousedown="mousedownFun(38)" onmouseup="mouseupFun(38)">向上(↑)</div>
    <div onmousedown="mousedownFun(39)" onmouseup="mouseupFun(39)">向右(→)</div>
    <p>使用左键、右键和上箭头键移动。</p> -->
    <div class="control-wrap" v-show="!showRank">
      <div class="control-btn"></div>
    </div>
    <audio
      :src="OSS_BASE + '/market/mp3/002.mp3'"
      ref="background_audio"
      loop
      id="bg-audio"
    />
    <audio
      :src="OSS_BASE + '/market/mp3/01.mp3'"
      ref="play_audio"
      id="play-audio"
    />
    <div class="game-top">
      <div class="game-take-time">Time: {{ takeTime }}s</div>
      <div class="game-rank-show" @click="showRankFun">Ranking List</div>
    </div>

    <div class="game-loading" v-if="!hideLoading">
      <div class="loading-wrap">
        <img
          :src="OSS_BASE + '/market/img/title.png'"
          style="margin-bottom: 20px"
        />
        <img :src="OSS_BASE + '/market/img/loading.gif'" class="loading-gif" />
        <div class="load-progress">
          <span
            class="load-progress-bar"
            :style="`width:${(loaded * 100) / len}%`"
          ></span>
        </div>
      </div>
    </div>
    <div class="game-over">
      <div class="game-over-wrap">
        <img
          :src="OSS_BASE + '/market/img/game over.png'"
          class="game-over-image"
        />
        <div class="game-over-btn" @click="restart">Try Again</div>
      </div>
    </div>
    <div class="game-success">
      <div class="game-success-wrap-mobile">
        <div>
          Time: <span class="game-success-time">{{ takeTime }}</span
          >s
        </div>
        <img
          :src="OSS_BASE + '/market/img/success.png'"
          class="game-success-image-mobile"
        />
        <div class="rank-btn" @click="showRankFun">Rank</div>
        <div class="restart-btn" @click="restart">Play Again</div>
      </div>
      <div class="game-success-wrap-pc">
        <div class="game-success-image-wrap">
          <img
            :src="OSS_BASE + '/market/img/success0.png'"
            class="game-success-image"
          />
          <div class="game-success-options">
            <div>
              Time: <span class="game-success-time">{{ takeTime }}</span
              >s
            </div>
            <div class="rank-btn" @click="showRankFun">Rank</div>
            <div class="restart-btn" @click="restart">Play Again</div>
          </div>
        </div>
        <img :src="OSS_BASE + '/market/img/floor.png'" />
      </div>
    </div>
    <Rank @statusChanged="hideRank" v-if="showRank" :isCn="isCn" />
  </div>
</template>

<script>
// 宝箱 01, 背景音 002,  按钮推墙 003, 弹簧 004, 气流通道 05, 水-游泳 006, 游戏失败 07, 胜利 08
window.audios = [
  "01.mp3",
  "002.mp3",
  "003.mp3",
  "004.mp3",
  "05.mp3",
  "006.mp3",
  "07.mp3",
  "08.mp3",
];
var images = [
  "left.png",
  "right.png",
  "1.png",
  "2.png",
  "3.png",
  "4.png",
  "5.png",
  "6.png",
  "7.png",
  "8.png",
  "left0.png",
  "right0.png",
  "01.png",
  "02.png",
  "rank/back.jpg",
  "rank/001.png",
  "rank/002.png",
  "rank/003.png",
  "rank/01.png",
  "rank/02.png",
  "rank/03.png",
  "rank/rule0.png",
  "game over.png",
  "success.png",
  "success0.png",
  "floor.png",
];
window.play_audio_func = function (file) {
  var src = play_audio.src,
    newSrc = OSS_BASE + "/market/mp3/" + file;
  if (src !== newSrc || (src == newSrc && play_audio.ended)) {
    play_audio.src = newSrc;
    play_audio.play();
  }
};
window.stop_audio_play = function () {
  play_audio.pause();
};
window.game = null;
window.map = null;

window.show_interface = function (id) {
  game.paused = true;
  document.querySelector(id).style.display = "block";
};
import Rank from "@/components/maze/Rank";
// import Rank from '@/components/rank';
import { mapData } from "@/util/mapData";
import { Clarity } from "@/util/mazeGame";
import { getPuzzleConfigure, submitAddTime, getMyRank } from "@/util/data.js";
import { showToast } from "@/util/utils.js";

var play_audio = null;
var controlButtonLeft = 0;
var controlButtonTop = 0;
var originalLeft = 0;
var originalTop = 0;

export default {
  components: {
    Rank,
  },
  computed: {
    messageState() {
      return this.$store.state.showMessage;
    },
    token: function () {
      return this.$store.state.token || window.localStorage.getItem("token");
    },
    userDetail() {
      return this.$store.state.userDetail;
    },
  },
  watch: {
    messageState(newVal) {
      if (!newVal) this.init();
    },
    userDetail(newVal) {
      if (newVal&&((this.loaded>0&&this.loaded!==this.len)||this.loaded===0)) this.loadImage();
    },
    // token() {
    //     let token =
    //       this.$store.state.token || window.localStorage.getItem("token");
    //     if (token) this.loadImage();
    //   },
  },
  data() {
    return {
      OSS_BASE,
      loaded: 0,
      len: images.length,
      hideLoading: false,
      showOver: false,
      takeTime: 0,
      takeTime0: 0,
      showRank: false,
      rankIndex: 0,
      bestTime: 0,
      playInterval: null,
      isCn: 0,
    };
  },
  created() {
    this.getConfig();
  },
  mounted() {},
  methods: {
    getConfig() {
      getPuzzleConfigure({ id: this.$route.params.id })
        .then((res) => {
          if (res.code === 1) {
            if (res.data == null) {
              // 该活动不存在
              showToast(this, "No data!");
              return;
            }
            // 后端没来得及加字段用is_validate_login 1代表中文
            this.isCn = res.data.is_validate_login|| this.$route.params.type==1;
            res.data.start_time = res.data.start_time.replace(/-/g, "/");
            res.data.end_time = res.data.end_time.replace(/-/g, "/");
            var start = new Date(res.data.start_time).getTime();
            var end = new Date(res.data.end_time).getTime();
            var now = Date.parse(new Date());
            if (now >= start && now <= end) {
              if (!this.checkLogin()) {
              } else {
                this.loadImage();
              }
            } else {
              showToast(this, "The activity was ended!");
            }
          } else {
            var msg = res.message || res.msg || "Fail!";
            showToast(this, msg);
          }
        })
        .catch((err) => {
          showToast(this, "Fail!");
        });
    },
    checkLogin() {
      let token =
        this.$store.state.token || window.localStorage.getItem("token");
      if (!token) {
        this.$store.commit("updateLoginState", true);
        return false;
      }
      return true;
    },
    showRankFun() {
      this.showRank = true;
      game.paused = true;
    },
    hideRank() {
      const successDOM = document.querySelector(".game-success");
      if (!successDOM.style.display || successDOM.style.display == "none")
        game.paused = false;
      this.showRank = false;
    },
    restart() {
      document.querySelector(".game-success").style.display = "none";
      document.querySelector(".game-over").style.display = "none";
      game.paused = false;
      game.load_map(map);
    },
    loadImage() {
      // this.loadMyRank();
      let _this = this;
      window.image_obj = [];
      for (var i = 0; i < images.length; i++) {
        image_obj[i] = new Image();
        image_obj[i].crossOrigin = "anonymous";
        image_obj[i].src = OSS_BASE + "/market/img/" + images[i];
        image_obj[i].onload = () => {
          _this.loaded += 1;
          if (_this.loaded == images.length) {
            setTimeout(() => {
              _this.hideLoading = true;
              play_audio = this.$refs.play_audio;
              this.playInterval = setInterval(this.toggleSound, 100);
              this.init();
            }, 1000);
          }
        };
      }
    },
    toggleSound() {
      let background_audio = this.$refs.background_audio;
      if (background_audio.paused) {
        // background_audio.paused = false;
        background_audio.play();
      } else {
        clearInterval(this.playInterval);
        this.clearInterval = null;
      }
    },
    init() {
      let _this = this;
      this.$refs.background_audio.play();
      var win_width =
          document.body.innerWidth || document.documentElement.clientWidth,
        win_height =
          document.body.innerHeight || document.documentElement.clientHeight;
      /* Setup of the engine */
      window.requestAnimFrame =
        window.requestAnimationFrame ||
        window.webkitRequestAnimationFrame ||
        window.mozRequestAnimationFrame ||
        window.oRequestAnimationFrame ||
        window.msRequestAnimationFrame ||
        function (callback) {
          return window.setTimeout(callback, 1000 / 60);
        };
      var canvas = document.getElementById("canvas"),
        ctx = canvas.getContext("2d");
      canvas.width = win_width;
      canvas.height = win_height;
      var keys_init =
        "game.current_map.keys[7].image = image_obj[3];game.left_image=image_obj[0];game.right_image=image_obj[1];game.current_map.keys[11].image = image_obj[2];game.current_map.keys[10].solid = 1;game.current_map.keys[10].image=image_obj[8]";
      map = {
        vue: _this,
        tile_size: 60,
        left_image: image_obj[0],
        right_image: image_obj[1],
        keys: [
          { id: 0, colour: "#1e264a", solid: 0 },
          { id: 1, colour: "#1e264a", solid: 0 },
          {
            id: 2,
            colour: "#555",
            solid: 1,
            bounce: 0.35,
            image: image_obj[8],
            // script: "stop_audio_play",
          },
          {
            id: 3,
            colour: "#47abc4",
            friction: { x: 0.9, y: 0.9 },
            gravity: { x: 0, y: 0.1 },
            jump: 1,
            fore: 1,
            script: "play_water",
          },
          {
            id: 4,
            colour: "#777",
            jump: 1,
            image: image_obj[7],
            script: "play_air",
            script0: "stop_audio_play",
          },
          {
            id: 5,
            colour: "#E373FA",
            solid: 1,
            bounce: 1.1,
            image: image_obj[4],
            script: "play_bounce",
          },
          { id: 6, colour: "#666", solid: 1, bounce: 0, image: image_obj[5] },
          {
            id: 7,
            colour: "#73C6FA",
            solid: 0,
            image: image_obj[3],
            script: "change_image",
          },
          {
            id: 8,
            colour: "#FADF73",
            solid: 0,
            script: "next_level",
            image: image_obj[9],
          },
          {
            id: 9,
            colour: "#C93232",
            solid: 0,
            script: "death",
            image: image_obj[6],
          },
          { id: 10, colour: "#1e264a", solid: 1, image: image_obj[8] },
          {
            id: 11,
            colour: "#0FF",
            solid: 0,
            script: "unlock",
            image: image_obj[2],
          },
        ],
        /* An array representing the map tiles. Each number corresponds to a key */
        data: mapData,
        /* Default gravity of the map */
        gravity: {
          x: 0,
          y: 0.3,
        },
        /* Velocity limits */
        vel_limit: {
          // x: 2,
          x: 4,
          y: 36,
          // y: 16
        },
        /* Movement speed when the key is pressed */
        movement_speed: {
          jump: 8,
          // jump: 6,
          // left: 0.4,
          // right: 0.4
          left: 1,
          right: 1,
        },
        /* The coordinates at which the player spawns and the colour of the player */
        player: {
          x: 2,
          y: 2,
          colour: "#f00",
        },
        /* scripts refered to by the "script" variable in the tile keys */
        scripts: {
          play_bounce: "play_audio_func(audios[3])",
          play_air: "play_audio_func(audios[4])",
          play_box: "play_audio_func(audios[0])", // 宝箱
          play_water: "play_audio_func(audios[5])",
          stop_audio_play: "stop_audio_play()",
          change_image:
            "if(game.current_map.keys[7].image != image_obj[13]){ game.current_map.keys[7].image = image_obj[13];game.left_image=image_obj[10];game.right_image=image_obj[11];play_audio_func(audios[0])}",
          // next_level:
          //   'play_audio_func(audios[7]);setTimeout(function(){alert("Yay! You won! Reloading map.");game.load_map(map);' +
          //   keys_init +
          //   "},500);",
          next_level:
            "play_audio_func(audios[7]);setTimeout(function(){game.vue.handleSuccess();" +
            keys_init +
            "},500);",
          death:
            'play_audio_func(audios[6]);setTimeout(function(){show_interface(".game-over");' +
            keys_init +
            "},500);",
          unlock:
            'if(game.current_map.keys[11].image != image_obj[12]){game.current_map.keys[11].image = image_obj[12];play_audio_func(audios[2]);game.current_map.keys[10].solid = 0;game.current_map.keys[10].image="";}',
        },
      };

      game = new Clarity();
      game.set_viewport(canvas.width, canvas.height);
      game.load_map(map);
      /* Limit the viewport to the confines of the map */
      game.limit_viewport = true;

      var Loop = function () {
        ctx.fillStyle = "#1e264a";
        ctx.fillRect(0, 0, canvas.width, canvas.height);

        game.update();
        game.draw(ctx);
        _this.takeTime = game.takeTime;
        // _this.takeTime0 = _this.dealTime(game.takeTime);
        window.requestAnimFrame(Loop);
      };

      Loop();
      this.initPanControl();
    },
    initPanControl() {
      // 滑动控制
      var _this = this;
      var controlWrap = document.querySelector(".control-wrap");
      var controlWrapWidth = controlWrap.innerWidth || controlWrap.clientWidth;
      var controlWrapHeight =
        controlWrap.innerHeight || controlWrap.clientHeight;
      var controlButton = document.querySelector(".control-btn");
      var controlButtonWidth =
        controlButton.innerWidth || controlButton.clientWidth;
      var controlButtonHeight =
        controlButton.innerHeight || controlButton.clientHeight;
      // 创建Hammer对象
      var hDiv = new Hammer(controlButton);
      hDiv.add(
        new Hammer.Pan({ direction: Hammer.DIRECTION_ALL, threshold: 4 })
      );
      originalLeft = controlButton.offsetLeft;
      originalTop = controlButton.offsetTop;
      // 拖拽事件
      hDiv.on("panstart", function () {
        controlButtonLeft = originalLeft;
        controlButtonTop = originalTop;
      });
      hDiv.on("panend", function () {
        controlButton.style.left = originalLeft + "px";
        controlButton.style.top = originalTop + "px";
        setTimeout(function () {
          game.panend();
        }, 100);
      });
      // 拖拽移动事件
      hDiv.on("panmove", function (e) {
        if (game.paused) return;
        // 因为活动容器和控制按钮宽和高一样，控制中心点轨迹是一个圆形
        var r = (controlWrapWidth - controlButtonWidth) / 2;
        var angle = Math.atan2(e.deltaY, e.deltaX);
        var position = _this.computePostion(e, r, angle);
        var temp = [];
        if (angle >= -1.77 && angle < -1.37) {
          // 向上 38
          game.key.left = false;
          game.key.up = true;
          game.key.right = false;
        } else if (angle >= -1.37 && angle < -0.2) {
          // 向右上 38 39
          game.key.left = false;
          game.key.up = true;
          if (game.player_image !== game.right_image)
            game.player_image = game.right_image;
          game.key.right = true;
        } else if (angle >= -0.2 && angle < 1.37) {
          // 向右 39
          game.key.left = false;
          game.key.up = false;
          if (game.player_image !== game.right_image)
            game.player_image = game.right_image;
          game.key.right = true;
        } else if (angle >= 1.37 && angle < 1.77) {
          // 向下
          game.panend();
        } else if (
          (angle >= 1.77 && angle <= 3.14) ||
          (angle < -2.94 && angle >= -3.14)
        ) {
          // 向左 37
          game.key.left = true;
          if (game.player_image !== game.left_image)
            game.player_image = game.left_image;
          game.key.up = false;
          game.key.right = false;
        } else if (angle < -1.77 && angle >= -2.94) {
          game.key.left = true;
          if (game.player_image !== game.left_image)
            game.player_image = game.left_image;
          game.key.up = true;
          game.key.right = false;
        }
        controlButton.style.left = position.x + "px";
        controlButton.style.top = position.y + "px";
      });
    },
    computePostion(e, r, angle) {
      var maxX = Math.max(r + r * Math.cos(angle), r - r * Math.cos(angle)),
        minX = Math.min(r + r * Math.cos(angle), r - r * Math.cos(angle));
      var maxY = Math.max(r + r * Math.sin(angle), r - r * Math.sin(angle)),
        minY = Math.min(r + r * Math.sin(angle), r - r * Math.sin(angle));
      var left = e.deltaX + controlButtonLeft,
        top = e.deltaY + controlButtonTop;
      return {
        x: this.processValue(left, maxX, minX),
        y: this.processValue(top, maxY, minY),
      };
    },
    processValue(value, max, min) {
      if (value >= max) return max;
      else if (value < min) return min;
      else return value;
    },
    handleSuccess() {
      show_interface(".game-success");
      this.successFun();
    },
    successFun() {
      let token =
        this.$store.state.token || window.localStorage.getItem("token") || "no";
      submitAddTime(
        {
          cost_time: game.takeTime,
          activity_id: this.$route.params.id,
        },
        token
      )
        .then((res) => {
          if (res.code === 1) {
            this.loadMyRank();
          } else {
            var msg = res.message || res.msg || "Fail!";
            showToast(this, msg);
          }
        })
        .catch((err) => {
          //showToast(this, "Fail!");
        });
    },
    async loadMyRank() {
      let token =
        this.$store.state.token || window.localStorage.getItem("token");
      const data = await getMyRank(
        {
          activity_id: this.$route.params.id,
        },
        token
      );
      if(data.code==1&&data.data){
        // this.initWxShare();
        // this.loadConfig(data.data.rank);
      } 
    },
    dealTime(data) {
      var time = data + "";
      var timeArr = time.split(".");
      var num = parseFloat(timeArr[0]);
      var str = "";
      var str1 = "";
      var str2 = "";
      var str3 = "";
      if (num > 60) {
        if (Math.floor(num / 60) < 10) {
          str1 = "0" + Math.floor(num / 60);
        }
        if (Math.floor(num / 60) >= 10) {
          str1 = Math.floor(num / 60);
        }
        if (num % 60 < 10) {
          str2 = "0" + (num % 60);
        }
        if (num % 60 >= 10) {
          str2 = num % 60;
        }
        str = str1 + ":" + str2;
      } else {
        if (num < 10) {
          str2 = "0" + timeArr[0];
        }
        if (num >= 10) {
          str2 = timeArr[0];
        }
        str = "00:" + str2;
      }
      if (timeArr[1]) {
        // 先判断字符串的个数
        if (timeArr[1].length == 1) {
          str = str + "." + timeArr[1] + "0";
        } else if (timeArr[1].length == 2) {
          str = str + "." + timeArr[1];
        }
      } else {
        str = str + ".00";
      }
      return str;
    },
  },
};
</script>

<style scoped lang="scss">
img {
  display: block;
  max-width: 100%;
}

* {
  margin: 0;
  padding: 0;
}

body {
  height: 100%;
  width: 100%;
  overflow: hidden;
}

.control-wrap {
  background: url(https://sanyglobal-img.sany.com.cn/market/img/circle.png) 100%
    100%;
  background-size: 100%;
  width: 90px;
  height: 90px;
  border-radius: 100%;
  position: relative;
  position: absolute;
  left: 50%;
  bottom: 40px;
  transform: translate(-50%, 0);
}

.control-btn {
  width: 50px;
  height: 50px;
  border-radius: 100%;
  background: url(https://sanyglobal-img.sany.com.cn/market/img/circle2.png);
  background-size: 100%;
  box-sizing: 4px 0 0 #000;
  position: absolute;
  left: 20px;
  top: 20px;
  /* left: 50%;
            top: 50%;
            transform: translate(-50%, -50%); */
  /* transition: all .3s; */
}

.canvas {
}

.game-loading,
.game-over,
.game-success {
  position: fixed;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  background: #1e264a;
}
.game-success {
  display: none;
}
.loading-wrap,
.game-over-wrap {
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  width: 280px;
  .loading-gif {
    width: 200px;
    margin: 0 auto;
  }
}
.load-progress {
  width: 100px;
  height: 8px;
  border-radius: 4px;
  overflow: hidden;
  border: 1px solid #fff;
  margin: 20px auto 0;
  position: relative;
  .load-progress-bar {
    transition: all 0.2s;
    position: absolute;
    left: 0;
    top: 0;
    width: 50%;
    height: 100%;
    background: #fff;
  }
}
.game-over {
  display: none;
}
.game-over-wrap {
  width: 420px;
}
.game-over-image {
}
.game-over-btn {
  background: #e60012;
  color: #fff;
  width: 220px;
  line-height: 2;
  font-size: 24px;
  text-align: center;
  border-radius: 24px;
  margin: 70px auto 0;
}
.game-top {
  position: fixed;
  right: 10px;
  top: 10px;
  font-size: 16px;
  line-height: 32px;
  font-weight: bold;
  color: #fff;
  display: flex;
}
.game-take-time {
  margin-right: 10px;
}
.game-rank-show {
  padding: 0 10px;
}

.game-success {
  background: #1e264a;
}
.game-success-wrap-mobile,
.game-success-wrap-pc {
  display: none;
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  width: 100%;
  text-align: center;
  color: #eeae44;
}
.game-success-wrap-mobile .game-success-time {
  font-size: 24px;
  font-weight: bold;
}
.game-success-wrap-mobile .rank-btn,
.game-success-wrap-pc .rank-btn {
  font-size: 18px;
  line-height: 2;
  width: 220px;
  text-align: center;
  background: #d02d27;
  border-radius: 18px;
  color: #fff;
  margin: 0 auto;
}
.game-success-wrap-mobile .restart-btn,
.game-success-wrap-pc .restart-btn {
  border: 1px solid #eeae44;
  color: #eeae44;
  line-height: 1.9;
  width: 218px;
  font-size: 18px;
  border-radius: 18px;
  margin: 20px auto 0;
}
.game-success-image-mobile {
  width: 80%;
  display: block;
  margin: 20px auto;
}
.game-success-wrap-pc {
  // width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  overflow: hidden;
}
.game-success-options {
  font-size: 18px;
}
.game-success-wrap-pc .game-success-time {
  font-size: 36px;
}
.game-success-image-wrap {
  position: relative;
  width: 44.6%;
  max-width: 860px;
  margin: 0 auto;
  margin-bottom: -30px;
}
.game-success-image-floor {
  width: 2524px;
  position: absolute;
  bottom: 0;
  left: 50%;
  transform: translate(-50%, 0);
}
.game-success-image {
  height: auto;
  width: 100%;
}
.game-success-options {
  position: absolute;
  left: calc(100% - 220px);
  bottom: 18.2%;
  width: 220px;
  text-align: center;
}
.game-success-options .rank-btn {
  margin-top: 20px;
}
@media screen and (max-width: 768px) {
  .game-success-wrap-mobile {
    display: block;
  }
  .game-over-wrap {
    width: 260px;
  }
  .game-success-wrap-pc {
    display: none;
  }
  .game-over-btn {
    width: 180px;
    font-size: 18px;
    border-radius: 18px;
    margin: 50px auto 0;
  }
}
@media screen and (max-width: 414px) {
  .game-top {
    font-size: 14px;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/Maze.vue